import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from "react-router-dom";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'antd';
import elGR from 'antd/lib/locale-provider/el_GR';

import {createBrowserHistory} from "history"

export const history = createBrowserHistory();

ReactDOM.render(
  <React.StrictMode>
    <ConfigProvider locale={elGR}>
      <Router  history={history}>
        <App />
      </Router>
    </ConfigProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
